module.exports = __webpack_public_path__ + "files/b0aa8dc99283ddf475c312d9694d4538.png";